import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0064FF",
      d: "M13 15H2.01C.903 15 0 14.11 0 13.015V2.985C0 1.89.903 1 2.01 1h7.98C11.098 1 12 1.89 12 2.985v6.578a1 1 0 1 1-2 0V2.984L2.01 3 2 13.015 13 13a1 1 0 1 1 0 2"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "#0064FF",
      d: "M13 15c-1.655 0-3-1.345-3-3V4.5h4.015C15.11 4.5 16 5.39 16 6.485V12c0 1.655-1.345 3-3 3m-1-8.505V12a1 1 0 1 0 2 0V6.485z"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "red",
      d: "M7.75 7.063h-3.5a1 1 0 1 1 0-2h3.5a1 1 0 1 1 0 2M7.75 10.563h-3.5a1 1 0 1 1 0-2h3.5a1 1 0 1 1 0 2"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }